import { Link } from "react-router-dom";
import { Box, Button, Container, Typography, useTheme } from "@mui/material";

import { FONT_PRIMARY } from "@/theme/typography";
import { ROUTES } from "@/utils/navigation";

import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import GetTrackmateStepper from "@/components/GetTrackmate/GetTrackmateStepper";
import Section from "@/components/Section";

const GetTrackmate = () => {
  const theme = useTheme();

  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 5.5 } }}>
        <BreadcrumbsNav />
      </Container>
      <Section pt={{ xs: 0, md: 4, lg: 6.5 }} pb={{ xs: 5, md: 8, lg: 24 }}>
        <GetTrackmateStepper />
      </Section>

      <Section
        pt={{ xs: 7.5, md: 8, lg: 21.25 }}
        pb={{ xs: 7.5, md: 8, lg: 12 }}
      >
        <Box
          sx={{
            backgroundColor: "#F9FAFC",
            padding: { xs: "24px", lg: "32px" },
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "16px",
          }}
        >
          <Box
            sx={{
              marginRight: { xs: "0px", lg: "20px" },
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "1.5rem !important",
                textAlign: { xs: "center", lg: "start" },
                fontFamily: FONT_PRIMARY,
                marginBottom: "8px",
              }}
            >
              Have questions?
            </Typography>
            <Typography
              sx={{
                color: theme.palette.text.secondary,
                fontSize: { xs: "1rem", md: "1.125rem" },
                marginBottom: { xs: "32px", lg: "0px" },
                textAlign: "center",
              }}
            >
              Can’t find the answer you’re looking for? Please chat to our
              friendly team
            </Typography>
          </Box>
          <Button
            component={Link}
            to={ROUTES.contactUs}
            variant="contained"
            color="primary"
            disableElevation
            sx={{
              paddingY: "14px",
              paddingX: "65px",
              height: "50px",
              textWrap: "nowrap",
            }}
          >
            Get in touch
          </Button>
        </Box>
      </Section>
    </>
  );
};

export default GetTrackmate;
